import { cn } from '../utils.js';

export function Loading({ full = false }: { full?: boolean }) {
  return (
    <div className={cn('flex items-center justify-center text-muted-foreground', full ? 'min-h-screen' : 'p-12')}>
      <div className="h-6 w-6 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent" />
    </div>
  );
}
